function Coffee() {
    return (
    <a
      className="buyButton"
      target="_blank"
      rel="noreferrer"
      href="https://www.buymeacoffee.com/yuwang"
    >
      <img
        className="coffeeImage"
        src="https://cdn.buymeacoffee.com/buttons/v2/default-yellow.png"
        alt="Buy Me A Coffee"
      />
    </a>
    );
}

export default Coffee;